import request from '@/plugins/admin_axios'

export const MountCalendar = async (data) => {
  const response = await request.post('/filial/mountCalendar/',data)
  return response.data
}

export const ListFilial = async (onlyActive = false, with_video = false, ignore_vinculo=false) => {
  const url = `/filial/list/${with_video ? 'all/' : ''}${onlyActive ? '?ativo=true': ''}${ignore_vinculo ? '&all=true' : ''}`;
  const response = await request.get(url);
  return response.data;
}

export const ListManipulacaoVagas = async (uuid_filial, data_inicial = null, data_final = null) => {
  let url = `/filial/manipulacao-vagas/list/${uuid_filial}/`
  if (data_inicial && data_final) url += `?data_inicial=${data_inicial}&data_final=${data_final}`
  const response = await request.get(url)
  return response.data
}

export const CreateManipulacaoVagas = async (data) => {
  const response = await request.post('/filial/manipulacao-vagas/save/', data)
  return response.data
}

export const DeleteManipulacaoVagas = async (id) => {
  const response = await request.delete('/filial/manipulacao-vagas/delete/', { data: { id } })
  return response.data
}
